import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from 'react-query'
import { Rotas } from './routes';
import theme from './theme';
import { ToastContainer } from 'react-toastify';

const queryClient = new QueryClient()

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Rotas />
      <ToastContainer />
    </ThemeProvider>
  </QueryClientProvider>
);